module.exports = __webpack_public_path__ + "static/media/SincerelyDiaryInterior3.604dff3d.jpg";